// extracted by mini-css-extract-plugin
module.exports = {"titleSection":"OutputPanel_titleSection_1Dygh","title":"OutputPanel_title_2SPe7"};